var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout layout_info"},[_c('landing-header'),_c('div',{staticClass:"layout__content"},[_vm._t("default")],2),(_vm.showFooter)?_c('landing-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }